// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__NbZgM","logoNavbar":"Logo_logoNavbar__5dYIZ","logoHeading":"Logo_logoHeading__Mr8wF"};